module.exports = "data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjI0IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHdpZHRoPSIyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Im0wIDBoMjR2MjRoLTI0eiIvPjxwYXRoIGQ9Im0xNS42IDQuOHYyLjg4aC0xLjQ0Yy0uNDk2OCAwLS43Mi41ODMyLS43MiAxLjA4djEuOGgyLjE2djIuODhoLTIuMTZ2NS43NmgtMi44OHYtNS43NmgtMi4xNnYtMi44OGgyLjE2di0yLjg4YzAtMS41OTA1ODAwOCAxLjI4OTQxOTktMi44OCAyLjg4LTIuODh6IiBmaWxsPSIjMDA5M2ZmIiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48L2c+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/facebook-icon-blue.svg
// module id = Wdjt
// module chunks = 0